import { Button, Modal, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import DynamicForm from '../../../../components/FormElements/DynamicForm/index'
import { FaEye } from 'react-icons/fa'
import * as Yup from 'yup'
import { Colors } from '../../../../config'
import { useDispatch, useSelector } from 'react-redux'
import { useMutation } from 'react-query'
import axiosInstance from '../../../../config/api'
import { setError, setMessage } from '../../../../store/common/generalSlice'

// const phoneNumberRegex = /^\+44[\s-]?(?:7\d{3}[\s-]?\d{6}|\d{2,4}[\s-]?\d{3,4}[\s-]?\d{3,4})$/;
const form = {
    name: 'Change Password',
    formFields: [
        {
            name: 'name',
            label: { value: 'Name:', classes: '' },
            type: 'text',
            placeholder: 'John Doe',
            width: { md: 24, sm: 24, xs: 24 },
            component: null,
            classes: 'custom-card-boxshadow outline-none h-10 pt-2',
        },
        {
            name: 'email',
            label: { value: 'Email:', classes: '' },
            type: 'email',
            placeholder: 'johndoe@gmail.com',
            width: { md: 24, sm: 24, xs: 24 },
            component: null,
            classes: 'custom-card-boxshadow outline-none h-10 pt-2',
        },
        {
            name: 'contactNo',
            label: { value: 'Contact Number:', classes: '' },
            type: 'text',
            placeholder: 'Enter Phone Number',
            width: { md: 24, sm: 24, xs: 24 },
            component: null,
            classes: 'custom-card-boxshadow outline-none h-10 pt-2',
        },
        {
            name: 'message',
            label: { value: 'Message:', classes: '' },
            type: 'textarea',
            placeholder: 'your message:',
            width: { md: 24, sm: 24, xs: 24 },
            component: null,
            classes: 'custom-card-boxshadow outline-none h-10 pt-2',
        },
    ],
    formValidation: {
        message: Yup.string().max(200).required(),
        contactNo: Yup.string().nullable().required()
                // .test(
                //     'is-valid-phone',
                //     (value) => !value || phoneNumberRegex.test(value) 
                // ),
    }
}

const ContactSupport = ({ contactSupportModal, setContactSupportModal }) => {

    const { profileData } = useSelector(state => state?.setting);
    const dispatch = useDispatch();

    const [editData, setEditData] = useState({
        name: '',
        email: '',
        contactNo: ''
    })

    useEffect(() => {
        setEditData({
            name: profileData?.fullName,
            email: profileData?.email,
            contactNo: profileData?.phoneNo
        })
    }, [profileData])

    const submitForm = () => {
        document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    const contactSupportMutation = useMutation(async (data) => {
        const { email, name, ...restData } = data;
        let res = await axiosInstance.post('/user/support-message', restData);
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message))
                setContactSupportModal(false)
            },
            onError: (error) => {
                dispatch(setError(error?.response?.data?.error?.message))
            }
        }
    )

    const handleSubmit = (data) => {
        contactSupportMutation.mutate(data)
    }

    return (
        <Modal
            open={contactSupportModal}
            width={400}
            footer={false}
            onCancel={() => setContactSupportModal(false)}
            centered
            destroyOnClose
        >
            <Row className='p-5 flex items-center justify-center'>
                <h2 className='text-lg font-semibold'>Contact Support</h2>
                <Row className='w-full mt-4'>
                    <DynamicForm
                        form={form}
                        onSubmit={handleSubmit}
                        editData={editData}
                    />
                    <Button
                        onClick={submitForm}
                        loading={contactSupportMutation?.isLoading}
                        htmlType='submit'
                        className='w-full h-10 mt-3 rounded-md outline-none border-none submit-btn'
                    >
                        Submit
                    </Button>
                </Row>
            </Row>
        </Modal>
    )
}

export default ContactSupport